const BANKS = {
  "10": "البنك الأهلي السعودي", "80": "مصرف الراجحي", "20": "بنك الرياض", "45": "البنك السعودي الأول (ساب)",
  "55": "البنك السعودي الفرنسي", "05": "مصرف الإنماء", "15": "بنك البلاد", "60": "بنك الجزيرة",
  "30": "البنك العربي الوطني", "65": "البنك السعودي للاستثمار", "90": "بنك الخليج الدولي",
};

export const normIban = (v) => String(v || "").replace(/\s+/g, "").toUpperCase();
export const bankFromIban = (v) => { const s = normIban(v); return s.startsWith("SA") && s.length >= 6 ? BANKS[s.slice(4, 6)] || "" : ""; };

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function exportRentedPdf(accounts, company) {
  const cols = ["المندوب", "المنصة", "صاحب الحساب", "رقم الهوية", "الجوال", "البنك", "الآيبان", "الإيجار", "الدباب", "الاستلام", "التسليم"];
  const rows = accounts.map(({ emp, platform, info: r }) => [
    `${emp.name}${emp.rider_id ? ` #${emp.rider_id}` : ""}`, platform, `${r.owner_name || "—"}${r.owner_id ? ` (${r.owner_id})` : ""}`,
    r.owner_national_id, r.owner_phone, r.owner_bank, r.owner_iban, r.rent ? `${r.rent} ر.س` : "", r.moto_plate,
    [r.since, r.wallet && `محفظة ${r.wallet}`].filter(Boolean).join(" · "), [r.handed_at, r.wallet_handed && `محفظة ${r.wallet_handed}`].filter(Boolean).join(" · "),
  ]);
  const total = accounts.reduce((s, a) => s + Number(a.info.rent || 0), 0);
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<!doctype html><html dir="rtl" lang="ar"><head><meta charset="utf-8"><title>الحسابات المستأجرة</title>
    <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@400;700&display=swap" rel="stylesheet">
    <style>@page{size:A4 landscape;margin:12mm}body{font-family:'IBM Plex Sans Arabic',Tahoma,sans-serif;color:#0f172a}h1{font-size:18px;margin:0}
    .sub{color:#64748b;font-size:11px;margin:4px 0 12px}table{width:100%;border-collapse:collapse;font-size:10.5px}
    th{background:#6d28d9;color:#fff;padding:6px 4px}td{border-bottom:1px solid #e2e8f0;padding:5px 4px;vertical-align:top}
    tr:nth-child(even) td{background:#f8fafc}.ltr{direction:ltr;unicode-bidi:embed}</style></head>
    <body><h1>الحسابات المستأجرة</h1><div class="sub">${esc([company, `${accounts.length} حساب`, `إجمالي الإيجار ${total} ر.س`, new Date().toLocaleDateString("ar-SA-u-nu-latn-ca-gregory")].filter(Boolean).join(" · "))}</div>
    <table><thead><tr>${cols.map((c) => `<th>${c}</th>`).join("")}</tr></thead><tbody>
    ${rows.map((r) => `<tr>${r.map((v, i) => `<td class="${[3, 4, 6].includes(i) ? "ltr" : ""}">${esc(v || "—")}</td>`).join("")}</tr>`).join("")}
    </tbody></table><script>window.onload=()=>setTimeout(()=>window.print(),400)</script></body></html>`);
  w.document.close();
  return true;
}
